import { Grid, Typography } from '@mui/material';
import { currency } from '@shared/hooks/currencies';

const Row = ({ children, sx }) => (
  <Typography
    variant="body2"
    sx={{
      display: 'flex', // ⚡ flex normal, no inline
      alignItems: 'center',
      whiteSpace: 'normal', // ⚡ permite salto de línea
      mb: 0.5, // opcional: espacio entre filas
      ...sx,
    }}
  >
    {children}
  </Typography>
);

const PriceDetailsSummary = ({
  ratePrice,
  provider,
  integration,
  business_types,
  supplier,
}) => {
  const isUSD = business_types.id === 2;
  const price =
    business_types.id === 1 ? ratePrice.details : ratePrice.details_USD;

  const rates = price.rates || {};

  const isInvalidValue = val =>
    val === undefined || val === null || val === 'NaN';

  const usdRate = Number(ratePrice?.USDvalue) || 1;

  const getValueInDisplayCurrency = val => {
    if (!isUSD) {
      return Number(val);
    }
    return Number(val) / usdRate;
  };

  const priceToShow = val => {
    if (isInvalidValue(val)) return '-';
    return currency(getValueInDisplayCurrency(val), isUSD);
  };

  const impuestos = [
    { key: 'impuestoO5', label: 'Impuesto PAÍS' },
    { key: 'impuestoQ1', label: 'Imp. ARCA' },
    { key: 'RG5450', label: 'Impuesto RG 5450' },
    { key: 'taxQ1', label: 'Impuesto RG 5463' },
    { key: 'impuestoRG7252', label: 'Impuesto RG 5272' },
    { key: 'RG5430', label: 'Impuesto RG 5430' },
  ];

  const impuestosActivos = impuestos.filter(
    ({ key }) => rates[key] && rates[key] !== 'NaN'
  );

  return (
    <Grid>
      <Row>Cot. USD: {currency(ratePrice.dollar, false)}</Row>

      {ratePrice.currency !== 'USD' && (
        <Row>
          Cot. {ratePrice.currency}: {currency(ratePrice.currency_value, false)}
        </Row>
      )}

      <Row>Proveedor: {supplier || provider?.name || '-'}</Row>

      <Row>Canal: {integration?.description || '-'}</Row>

      <Row>Costo neto: {currency(rates.Base, isUSD)}</Row>

      {ratePrice.currency !== 'USD' && (
        <Row>
          Costo neto:{' '}
          {currency(
            ratePrice.currency_amount,
            false,
            false,
            ratePrice.currency
          )}
        </Row>
      )}

      <Row>Markup: {currency(rates.Marckup, isUSD)}</Row>

      <Row>IVA: {currency(isUSD ? price.b2b?.iva : rates.IVA, isUSD)}</Row>

      {price.charges > 0 && (
        <Row>Costo de Gestión: {currency(price.charges, isUSD)}</Row>
      )}

      {impuestosActivos.map(({ key, label }) => (
        <Typography key={key} variant="body2">
          {label}: {priceToShow(rates[key])}
        </Typography>
      ))}

      <Row sx={{ mt: 0.5 }}>
        <strong style={{ marginRight: 4 }}>TOTAL:</strong>
        {currency(isUSD ? price.b2b?.total : price.total, isUSD)}
      </Row>
    </Grid>
  );
};

export default PriceDetailsSummary;
